import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { AiOutlineDown, AiOutlineRight } from 'react-icons/ai';

export type BreachGroupHeaderProps = {
  name: string;
  /** The date under a visit group's name. Absent for the other dimensions. */
  subtitle?: string;
  /** Real section membership, so a collapsed group still reports a truthful count. */
  count: number;
  collapsed: boolean;
  onToggle: () => void;
};

/** The band above each group, shaped like the shifts grid's `ShiftsGroupHeader`. */
export const BreachGroupHeader = ({ name, subtitle, count, collapsed, onToggle }: BreachGroupHeaderProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onToggle}
      // The whole band is the target, not just the chevron: a 12-pixel icon is a
      // poor thing to ask someone to hit for every patient on the list.
      className="w-full flex items-center gap-2 py-2 px-1 text-left hover:bg-slate-50 rounded"
      aria-expanded={!collapsed}
    >
      <Button
        type="text"
        size="small"
        tabIndex={-1}
        icon={collapsed ? <AiOutlineRight /> : <AiOutlineDown />}
        aria-label={collapsed ? t('doctor-breaches-group-expand') : t('doctor-breaches-group-collapse')}
      />
      <Typography.Text strong className="truncate">
        {name}
      </Typography.Text>
      {subtitle && (
        <Typography.Text type="secondary" className="!text-xs">
          {subtitle}
        </Typography.Text>
      )}
      <Typography.Text type="secondary" className="!text-xs ml-auto shrink-0">
        {t('doctor-breaches-group-count', { count })}
      </Typography.Text>
    </button>
  );
};

export default BreachGroupHeader;
